import { Select } from "@mui/material";
import React, { } from "react";
import propTypes from "prop-types";
import FloatingInputLabel from "../../../components/editable/EditableField/components/FloatingInputLabel";
import flex from "../../../styles/flex";
import { useTranslation } from "react-i18next";

const DataSourceTypes = [
    { name: 'MySQL', value: 'mysql' },
    { name: 'BigQuery', value: 'bigquery' },
]

const DataSourceSelector: React.FunctionComponent<{
    label: string,
    value?: string;
    onChange: (value: string) => void;
}> = (props) => {
    const { t } = useTranslation();
    return <div style={flex.flexRows}>

        <div style={flex.flexAuto}>
            <div style={{ marginTop: 3 }}>
                <FloatingInputLabel label={props.label}>
                    <Select

                        native
                        style={{ width: "100%", minWidth: 218, maxWidth: 218, borderRadius: 5, padding: 5 }}

                        value={props.value}
                        onChange={(e) => {
                            props.onChange(e.target.value as string);
                        }}
                    >
                        <option value={""} title={t("reports.optionSelect")}>- {t("reports.select")} -</option>
                        {DataSourceTypes.map((dataSource) => {
                            return <option key={dataSource.name} value={dataSource.value} title={dataSource.name}>{dataSource.name}</option>;
                        })}
                    </Select>
                </FloatingInputLabel>
            </div>
        </div>
    </div>
}
DataSourceSelector.propTypes = {
    label: propTypes.string.isRequired,
    value: propTypes.string,
    onChange: propTypes.func.isRequired,
}

export default DataSourceSelector;